import React from 'react'
import { connect } from 'react-redux'
import { currentFolderSelector } from '../../store/selectors/selectors'
import { sidebarShowingSelector } from '../../store/selectors/sidebarSelectors'
import Folder from './Folder'
import { compose, branch, renderComponent } from 'recompose'
import { firebaseConnect } from 'react-redux-firebase'
import { Content } from 'common/components'
import Loader from 'app/components/common/Loader'

const FolderContainer = compose(
  firebaseConnect(({ match }) => [`/folders/${match.params.folderId}`]),
  connect(
    state => ({
      folder: currentFolderSelector(state),
      sidebarShowing: sidebarShowingSelector(state)
    })
  ),
  branch(
    ({ folder }) => !folder,
    renderComponent(() => (
      <Content>
        <Loader />
      </Content>
    ))
  )
)(Folder)

export default FolderContainer
